import React from 'react'
import styles from './Footer.module.scss'
// import phoneIcon from '@assets/img/phone.png'
import emailIcon from '@assets/img/email.png'
import dianpingDownload from '@assets/img/dianpingDownload.png'
import meituanDownload from '@assets/img/meituanDownload.png'
import travelDownload from '@assets/img/travelDownload.png'
import { withTranslator } from '@common/hoc/translatorHoc'
import { WithI18nProps } from '@/types/i18n'
import { createAgentI18n } from '@/utils/i18n'

const Footer: React.FC<WithI18nProps> = (props) => {
  const { i18n } = props
  const t = React.useMemo(() => createAgentI18n(i18n), [i18n])
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.leftInfo}>
          <div className={styles.title}>{t('contactUs', "联系我们")}</div>
          {/* <div className={styles.contactRow}>
            <div className={styles.icon}><img src={phoneIcon} alt="phone" /></div>
            <div className={styles.contactItem}>
              10105557
            </div>
          </div> */}
          {/* <div className={styles.sub}>{t('contactUsDescription', "平台客服热线（周一至周五 9:00-23:00）")}</div> */}

          <div className={styles.contactRow}>
            <div className={styles.icon}><img src={emailIcon} alt="email" /></div>
            <div className={styles.contactItem}>
              hb.overseas.sot@meituan.com
            </div>
          </div>
          <div className={styles.sub}>{t('contactUsEmailDescription', "商务合作邮箱")}</div>

        </div>
        <div className={styles.divider} />


        <div className={styles.rightApps}>
          <div className={styles.title}>{t('downloadApplications', "下载应用")}</div>
          <div className={styles.qrGrid}>
            <div className={styles.qrItem}>
              <div className={styles.qrBox}><img src={dianpingDownload} alt="dianpingDownload" /></div>
              <div className={styles.qrText}>{t('scanDownloadDianping', "大众点评")}</div>
            </div>
            <div className={styles.qrItem}>
              <div className={styles.qrBox}><img src={meituanDownload} alt="meituanDownload" /></div>
              <div className={styles.qrText}>{t('scanDownloadMeituan', "美团")}</div>
            </div>
            <div className={styles.qrItem}>
              <div className={styles.qrBox}><img src={travelDownload} alt="travelDownload" /></div>
              <div className={styles.qrText}>{t('scanDownloadTravel', "美团境外商家")}</div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

const FooterWithTranslator = withTranslator(Footer)
export default FooterWithTranslator

